// Share API helpers.
import { BACKEND_URL } from "./api";

function url(p) { return `${BACKEND_URL}${p}`; }

async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch (_) { /* */ }
  if (!res.ok) {
    const err = new Error(
      (body && (body.detail?.message || body.detail?.error || body.detail || body.error)) ||
      `HTTP ${res.status}`
    );
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function createShare({ language, code, files, entry_file, name }) {
  const res = await fetch(url("/api/shares"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      language, code: code || "",
      files: files || null,
      entry_file: entry_file || null,
      name: name || null,
    }),
  });
  return jsonOrThrow(res);
}

export async function getShare(id) {
  const res = await fetch(url(`/api/shares/${encodeURIComponent(id)}`));
  return jsonOrThrow(res);
}

export function buildShareUrl(id) {
  if (typeof window === "undefined") return "";
  const origin = window.location.origin.replace(/\/$/, "");
  return `${origin}/?s=${encodeURIComponent(id)}`;
}
